import React from 'react';
import styled from 'styled-components';
import { SIZES } from '@fupa/fupa-uikit';
import { ErrorHandler } from 'app/components/error/ErrorHandler';
import { Helmet } from 'react-helmet-async';
import { useSelector } from 'react-redux';
import { reduxSelectDistrict } from 'app/hooks/reduxSelectDistrict';
import { TITLE_POSTFIX } from 'app/seo/seo.constants';
import AllTransfers from 'app/components/district/transfers/AllTransfers';
import { useRestoreData } from 'app/hooks/dataHooks';
import DistrictTransfersResponse from 'app/models/district/transfers/DistrictTransfersResponse';
import queryString from 'query-string';
import { useLocation } from 'react-router';
import { useAppBarTitle } from 'app/hooks/appBar/useAppBarTitle';
import { useDistrictChangeAppBarParent } from 'app/hooks/appBar/useDistrictChangeAppBarParent';
const Wrapper = styled.div.withConfig({
  componentId: "sc-26ngtg-0"
})(["margin-top:calc(", " + env(safe-area-inset-top));display:flex;flex-direction:column;align-items:center;"], SIZES['80']);
export default function DistrictAllTransfersPage() {
  const {
    name
  } = useSelector(reduxSelectDistrict);
  const location = useLocation();
  const searchQuery = queryString.parse(location.search);

  // refactor with task https://fupa.atlassian.net/browse/DV-17149
  useAppBarTitle('Alle Transfers');
  useDistrictChangeAppBarParent();
  const {
    restoredData
  } = useRestoreData('DistrictAllTransfersPage');
  const initialState = restoredData ? new DistrictTransfersResponse(restoredData) : undefined;
  const title = "Wechselb\xF6rse: Alle Transfers in ".concat(name).concat(TITLE_POSTFIX);
  const meta = [{
    name: 'description',
    content: "".concat(name, " Wechselb\xF6rse: Alle Transfers - Aktuelle Transfermeldungen und Trainerwechsel \xFCber einen Neuzugang oder Abgang in den Teams des Fu\xDFballkreises ").concat(name, " in der \xDCbersicht.")
  }, {
    name: 'robots',
    content: 'noindex, follow'
  }];
  const canonical = searchQuery !== null && searchQuery !== void 0 && searchQuery.page ? /*#__PURE__*/React.createElement("link", {
    rel: "canonical",
    href: location.pathname
  }) : null;
  return /*#__PURE__*/React.createElement(Wrapper, {
    "data-sentry-element": "Wrapper",
    "data-sentry-component": "DistrictAllTransfersPage",
    "data-sentry-source-file": "DistrictAllTransfersPage.tsx"
  }, /*#__PURE__*/React.createElement(Helmet, {
    meta: meta,
    title: title,
    "data-sentry-element": "Helmet",
    "data-sentry-source-file": "DistrictAllTransfersPage.tsx"
  }, canonical), /*#__PURE__*/React.createElement(ErrorHandler, {
    subroute: false,
    "data-sentry-element": "ErrorHandler",
    "data-sentry-source-file": "DistrictAllTransfersPage.tsx"
  }, /*#__PURE__*/React.createElement(AllTransfers, {
    initialState: initialState,
    "data-sentry-element": "AllTransfers",
    "data-sentry-source-file": "DistrictAllTransfersPage.tsx"
  })));
}